import { render, staticRenderFns } from "./ModalRegistration.vue?vue&type=template&id=8767926e&scoped=true"
import script from "./ModalRegistration.vue?vue&type=script&lang=ts"
export * from "./ModalRegistration.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegistration.vue?vue&type=style&index=0&id=8767926e&prod&lang=css"
import style1 from "./ModalRegistration.vue?vue&type=style&index=1&id=8767926e&prod&scoped=true&lang=css"
import style2 from "./ModalRegistration.vue?vue&type=style&index=2&id=8767926e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8767926e",
  null
  
)

export default component.exports